<template>
  <div class="game-container">
    <div id="game-container"><canvas id="gameCanvas"></canvas></div>
  </div>
</template>

<script>
import createjs from 'createjs-collection';
import defaultMixins from '../../mixins/defaultMixinV2';
import createjsMixin from '../../mixins/createjsMixinV2';
export default {
  name: 'mp-sorting-v2',
  mixins: [defaultMixins, createjsMixin],
  components: {},
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      initData: {},
      width: 0,
      height: 0,
      offset: {},
      stage: {},
      figureArea: {},
      touchArea: {},
      line: {},
      mousedown: false,
      images: [],
      point: {},
      lines: [],
      moved: 0,
      ticker: false,
      animation: false,
      movesTo: [],
      targets: [],
      corrects: [],
      clones: [],
      maxClone: 0,
    };
  },
  beforeMount() {
    this.prototypeArray();
  },
  mounted() {
    this.ticker = createjs.Ticker;
    this.setDataGame();
    this.initGame();
    if (this.initData.inLine === true) {
      var self = this;
      this.images.forEach(function (gr) {
        gr.forEach(function (item) {
          if (item.type == 'source') {
            if (self.targets[item.target] === undefined) self.targets[item.target] = [];
            self.targets[item.target].push(item);
          }
        });
      });
    }
    createjs.Touch.enable(this.stage);
    // console.log(createjs.Touch.isSupported());
  },
  created() {},
  methods: {
    stageMouseDown(e) {
      if (!this.mousedown) {
        this.resetCheckStatus();
        var grx = -1;
        var ix = -1;
        this.images.forEach(function (gr, i) {
          gr.forEach(function (cont, j) {
            if (e.target.id == cont.id) {
              ix = j;
              grx = i;
            }
          });
        });
        if (ix >= 0 && grx >= 0 && !this.images[grx][ix].block) {
          this.moved = this.images[grx][ix];
          if (this.initData.inLine === true) {
            this.moved.posStart = { x: this.moved.x, y: this.moved.y };
          }
          this.moved.sorts = this.findInTargets();
          this.moved.stageX = e.stageX - this.offset.x;
          this.moved.stageY = e.stageY - this.offset.y;
          this.moved.scaleX = 1;
          this.moved.scaleY = 1;
          this.stage.setChildIndex(this.moved, this.stage.getNumChildren() - 1);
          this.stage.on('stagemousemove', this.stageMouseMove);
          this.mousedown = true;
        }
      }
    },
    findInTargets(del) {
      var flg = false,
        self = this;
      this.targets.forEach(function (tar) {
        let inx = tar.indexOf(self.moved);
        if (inx > -1) {
          if (del === true) tar.splice(inx, 1);
          flg = inx;
        }
      });
      return flg;
    },
    sortsTargets() {
      var self = this;
      this.targets.forEach(function (tar, i) {
        tar.forEach(function (item, j) {
          if (item !== undefined && (self.images[i][j].x !== item.x || self.images[i][j].y !== item.y)) {
            item.pos = { x: self.images[i][j].x, y: self.images[i][j].y };
            item.move = true;
            self.movesTo.push(item);
          }
        });
      });
    },
    stageMouseUp(e) {
      if (this.mousedown) {
        this.mousedown = false;
        var self = this;
        var ix = -1,
          grx = -1,
          tx = -1,
          grt = -1;
        if (this.initData.inLine !== true) {
          this.stage.getObjectsUnderPoint(this.moved.stageX, this.moved.stageY).forEach(function (bmp) {
            // console.log(bmp);
            self.images.forEach(function (gr, i) {
              if (bmp.parent.type === 'source' && bmp.id != self.moved.id && self.targets[i] !== undefined) {
                tx = self.targets[i].indexOf(bmp.parent);
                grt = i;
              }
              gr.forEach(function (indx, j) {
                if (indx.id == bmp.id) {
                  ix = j;
                  grx = i;
                }
              });
            });
          });
          if (this.images[grx][ix].type !== 'target') {
            this.moved.pos = { x: this.moved.posStart.x, y: this.moved.posStart.y };
            this.moved.move = true;
            this.movesTo.push(this.moved);
            if (this.moved.sorts !== false) {
              this.findInTargets(true);
              this.sortsTargets();
              this.moved.sorts = false;
            }
          } else {
            if (this.moved.sorts !== false && tx > -1) {
              let offs = tx - this.moved.sorts;
              this.targets[grt].move(this.moved, offs);
            } else if (this.moved.sorts === false && tx == -1) {
              let flg = false;
              for (let i = 0; i < this.targets[grx].length; i++) {
                if (this.targets[grx][i] === undefined) {
                  this.targets[grx][i] = this.moved;
                  flg = true;
                  break;
                }
              }
              if (!flg) this.targets[grx].push(this.moved);
            } else if (this.moved.sorts === false && tx > -1) {
              this.targets[grt].push(this.moved);
              this.targets[grt].move(this.moved, tx - this.targets[grt].length + 1);
            } else {
              this.findInTargets(true);
              this.targets[grx].push(this.moved);
            }
            this.sortsTargets();
            if (this.images[grx][ix].width != this.moved.width)
              this.moved.scaleX = this.images[grx][ix].width / this.moved.width;
            if (this.images[grx][ix].height != this.moved.height)
              this.moved.scaleY = this.images[grx][ix].height / this.moved.height;
          }
        } else {
          var drop = true;
          this.stage.getObjectsUnderPoint(this.moved.stageX, this.moved.stageY).forEach(function (bmp) {
            if (
              bmp.parent.type !== undefined &&
              bmp.parent.type !== 'target' &&
              bmp.parent !== self.moved &&
              bmp.parent.name !== null
            ) {
              if (bmp.parent.target == self.moved.target) {
                drop = false;
                tx = self.targets[self.moved.target].indexOf(bmp.parent);
              }
            }
          });
          if (drop) {
            this.moved.pos = { x: this.moved.posStart.x, y: this.moved.posStart.y };
            this.moved.move = true;
            this.movesTo.push(this.moved);
          } else {
            let offs = tx - this.moved.sorts;
            this.targets[this.moved.target].move(this.moved, offs);
          }
          this.sortsTargets();
        }
      }
      this.stage.removeAllEventListeners('stagemousemove');
    },
    tick(e) {
      if (this.movesTo.length > 0) {
        for (let i = 0; i < this.movesTo.length; i++) {
          this.anim(this.movesTo[i], { x: this.movesTo[i].pos.x, y: this.movesTo[i].pos.y, move: true });
          if (this.movesTo[i].x == this.movesTo[i].pos.x && this.movesTo[i].y == this.movesTo[i].pos.y) {
            this.movesTo.splice(i, 1);
          }
        }
      } else {
        if (!this.ticker.paused) {
          if (!this.mousedown) {
            this.ticker.paused = true;
            this.moved.move = false;
          }
        }
      }
      this.stage.update(e);
    },
    resetGameAction() {
      this.newGame();
      if (this.initData.inLine === true) {
        var self = this;
        this.images.forEach(function (gr) {
          gr.forEach(function (item) {
            if (item.type == 'source') {
              if (self.targets[item.target] === undefined) self.targets[item.target] = [];
              self.targets[item.target].push(item);
            }
          });
        });
      }
    },
    checkGameAction() {
      // console.log('CHECK');
      var isCorrect = true;
      var self = this,
        count = [];
      this.images.forEach(function (gr, i) {
        count[i] = 0;
        gr.forEach(function (bmp, j) {
          if (bmp.type == 'target') {
            count[i]++;
            for (let k = 0; k < self.targets[i].length; k++) {
              if (self.targets[i][k] !== undefined) {
                if (k == j) {
                  self.targets[i][k].correct.forEach(function (cor) {
                    if (cor.id == bmp.id) {
                      self.targets[i][k].block = bmp.block = true;
                    }
                  });
                }
                if (bmp.block !== true) {
                  bmp.block = false;
                  isCorrect = false;
                }
              }
            }
          }
        });
      });
      if (isCorrect) {
        this.targets.forEach(function (tar, i) {
          if (count[i] !== tar.length) isCorrect = false;
          for (let j = 0; j < tar.length; j++) {
            if (tar[j] === undefined) isCorrect = false;
            else if (!tar[j].block) {
              isCorrect = false;
            }
          }
        });
      }
      this.targets.forEach(function (tar) {
        tar.forEach(function (el) {
          el.block = isCorrect;
        });
      });
      return isCorrect;
    },
  },
  beforeDestroy() {
    this.beforeDestroy();
  },
};
</script>
<style lang="scss"></style>
<style lang="scss" scoped>
.game-container {
  display: flex;
  padding: 160px 50px 100px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  // border: 1px solid black;
}

#game-container {
  margin: 0;
  width: 100%;
  height: 100%;
}

canvas {
}
</style>
